import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../../core/core.module';
import { RolActividadCheckElement, VinculacionRolActividadInput } from '../../roles.model';


@Component({
  selector: 'rpe-vinculacion-rol-actividad-form-dialog',
  templateUrl: './vinculacion-rol-actividad-form-dialog.component.html',
  styleUrls: ['./vinculacion-rol-actividad-form-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VinculacionRolActividadFormDialog implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  actividadesCheck: RolActividadCheckElement[] = [];
  actividadesSeleccionadas: RolActividadCheckElement[] = [];

  firstFormGroup: FormGroup;
  customTemplate: TemplateRef<any>;
  formValid = false;

  constructor(
    public dialogRef: MatDialogRef<VinculacionRolActividadFormDialog>,
    @Inject(MAT_DIALOG_DATA) public data: VinculacionRolActividadInput,
    private _formBuilder: FormBuilder
  ) {}

  @ViewChild(MatStepper) stepper: MatStepper;

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });

    // todas las actividades arrancan seleccionadas
    this.data.rolesActividadConNombre.forEach((actividad: any) => {
      const auxAC: RolActividadCheckElement = {
        value: true,
        rolActividadConNombre: actividad
      };
      this.actividadesCheck.push(auxAC);
    });
    this.actividadesSeleccionadas = [...this.actividadesCheck];
  }

  formStatusChanges(status: any) {
    this.formValid = status === 'VALID';
  }

  formValueChanges(rolesActividadConNombre: any) {
    this.actividadesSeleccionadas = rolesActividadConNombre;
    if (this.contarCheckeadas() == 0) {
      this.stepper.selected.completed = false;
    }
  }

  onSiguiente() {
    if (this.contarCheckeadas() > 0) {
      this.stepper.selected.completed = true;
      this.stepper.next();
      let auxAS = '';
      this.actividadesSeleccionadas.forEach((aS) => {
        auxAS = auxAS.concat(aS.rolActividadConNombre.nombreActividad, ', ');

      });
      this.data = {
        ...this.data,
        actividadesSeleccionadas: auxAS
      };
    }
  }

  contarCheckeadas(): number {
    let cantidad = 0;
    this.actividadesSeleccionadas.forEach((aS) => {
      if (aS.value) {
        cantidad++;
      }
    });
    return cantidad;
  }

  onAtras() {
    this.stepper.selected.completed = true;
    this.stepper.previous();
  }

  onSubmit() {
    this.dialogRef.close(this.actividadesSeleccionadas);
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}
